<template>
  <div class="course-detail" v-if="post.post">
    <div class="course-top">
      <div class="top-text">
        <p>{{post.title}}</p>
      </div>
      <div class="course-video">
        <div class="video-content">
         <video id="id_video_container">
         </video>
        </div>
        <div class="video-footer" v-if="post.post">
          <img style="margin-left:16px;" :src="seeUrl">
          <span style="padding-left: 5px; ">{{post.post.pageview}}人已学习</span>
          <i
            class="iconcool iconcool-like like-course"
            :class="{'unlike-course': !post.isLike}"
            @click="likeCourse"/>
          <span>{{post.likeUsers && post.likeUsers.length}}人点赞</span>
        </div>
      </div>
    </div>
    <div class="course-bottom">
      <div class="course-bottom-left">
        <div class="course-describe">
          <div class="ue-tabs" id="ue-tabs">
            <ul @click.stop="activeTab" id="ue-tabs-ul" :style="tabStyle">
              <li
                v-for="(item, index) in tabs"
                :title="item.name"
                :class="{active: index === activeIndex}"
                :key="index"
              >{{item.name}}</li>
            </ul>
          </div>
          <div class="course-relative">
            <div v-if="brief" class="brief">
              <div class="course-brief-title">
                <span>课程简介</span>
              </div>
              <div class="brief-context" v-html="post && post.post && post.post.post"></div>
            </div>
            <div v-if="comment" class="comment">
              <div class="course-comment-title">
                <span>参与评论</span>
              </div>
              <Comment :head="true" commentListIndex="author" />
              <comment-list
                v-if="post && post.post"
                style="margin-top: 31px;"
                :id="post.post._id"
                :comments="post.post.comments"
              />
            </div>
            <div v-if="source" class="source">
              <div class="course-source-title">
                <span>内容报告</span>
              </div>
              <attachment v-if="articleAttachment && articleAttachment.post && articleAttachment.post.sourceFile" :sourceFile="articleAttachment.post.sourceFile" :id="articleAttachment.post.id"  />
            </div>
          </div>
        </div>
        <div class="course-cards-box">
          <div class="course-cards-text">
            <p>相关课程</p>
          </div>
          <course-card
            v-for="item in post.posts.slice(0,4)"
            :key="item._id"
            :course="item"
            class="course-cards"
          />
          <course-card/>
        </div>
      </div>
      <div class="course-bottom-right">
        <user-card :user="post.post && post.post.user"/>
      </div>
    </div>
  </div>
</template>
<script>
import Comment from "@/components/post/Comment";
import CommentList from "@/components/post/CommentList";
import CourseCard from "@/components/course/CourseCard.vue";
import Attachment from '@/components/common/Attachment'
import UserCard from "@/components/common/UserCard.vue";
import see from "@/assets/img/look.png";
import like from "@/assets/img/smallLike.png";
import { mapGetters, mapActions } from "vuex";
export default {
  name: "course-detail",
  data() {
    return {
      seeUrl: see,
      likeUrl: like,
      tabs: [{ name: "课程描述" }, { name: "学员讨论" }, { name: "相关资源" }],
      activeIndex: 0,
      tabStyle: {
        transform: "translateX(0)"
      },
      tabScrollLeft: true,
      brief: true,
      comment: false,
      source: false,
      articleAttachment: ''
    };
  },
  components: {
    CourseCard,
    UserCard,
    Comment,
    CommentList,
    Attachment
  },
  computed: {
    ...mapGetters('post', ['post']),
    ...mapGetters('home', ['user']),
  },
  async mounted() {
    // let post = await this.getPost(this.$route.params.id)
    let post = await this.getOnlyCourse(this.$route.params.id)
    if(!this.$route.query.articleType) {
      const path = this.$route.path
      const query = this.$route.query
      this.$router.push({
        path,
        query: {...query, articleType: post.post.category2[0]._id}
      })
    }
    let video = await this.getPlayInfo(post.post.videoFileId)
    this.initVideo(video)
  },
  methods: {
    ...mapActions('post', ['getPost', 'likePost', 'getOnlyCourse']),
     async activeTab(event) {
      this.activeIndex = this.tabs.findIndex(
        ele => ele.name === event.srcElement.title
      );
      switch (this.activeIndex) {
        case 0:
          this.brief = true;
          this.comment = this.source = false;
          break;
        case 1:
          this.comment = true;
          this.brief = this.source = false;
          break;
        case 2:
          this.source = true;
          this.brief = this.comment = false;
          break;
        default:
          break;
      }
      let _this = this
      if (this.activeIndex === 2) {
         _this.articleAttachment = await _this.getPost(_this.$route.params.id)
        console.log(_this.articleAttachment)
      }
    },
    changeTabStyle() {
      let scrollWidth = 0;
      if (this.tabScrollLeft) {
        scrollWidth =
          document.querySelector("#ue-tabs-ul").scrollWidth -
          document.querySelector("#ue-tabs").getClientRects()[0].width +
          20;
      }
      this.tabStyle.transform = `translateX(-${scrollWidth}px)`;
    },
    likeCourse () {
       if(!this.user) {
        this.isLogin('登录后点赞')
        return
      }
      if(this.post.isLike) return
      this.likePost({uid: this.user.uid, id: this.post.post.id})
    },
    initVideo (data) {
        if (!!data.errcode) {
          console.log(data.msg);
          console.log('请求错误');
        }
        let options = {
          ...data.data,
          plugins:{
            ContinuePlay: {
                auto: true,
                text: '已定位',
                btnText: '重新开始'
            }
          },
          controlBar: {
            playToggle: true,
            progressControl: true,
            volumePanel: true
          }
        }
        TCPlayer('id_video_container', options);
     }
  }
};
</script>

<style lang="scss">
.course-detail {
  > .course-top {
    display: flex;
    flex-direction: column;
    width: 1180px;
    margin-top: -17px;
    > .top-text {
      width: 1180px;
      float: left;
      > p {
        font-size: 20px;
        font-family: MicrosoftYaHei-Bold;
        font-weight: bold;
        color: rgba(51, 51, 51, 1);
        line-height: 26px;
        text-align: left;
      }
    }
    > .course-video {
      width: 1180px;
      height: 585px;
      background: rgba(255, 255, 255, 1);
      box-shadow: 0px 0px 16px 0px rgba(51, 51, 51, 0.1);
      margin-top: 19px;
      > .video-content {
        width: 1180px;
        height: 529px;
        >div{
          width: 1180px;
          height: 529px;
        }
      }
      > .video-footer {
        width: 1180px;
        height: 56px;
        padding-top: 19px;
        .like-course {
          color: rgb(153, 153, 153);
          margin-left: 54px;
          &:hover {
            cursor: pointer;
          }
        }
        .unlike-course {
          &:hover {
            color: #333333;
          }
        }
        > * {
          float: left;
        }
        > span {
          font-size: 14px;
          font-family: MicrosoftYaHei-Bold;
          font-weight: bold;
          color: rgba(153, 153, 153, 1);
          line-height: 19px;
          padding-left: 4px;
        }
      }
    }
  }
  > .course-bottom {
    width: 1180px;
    height: 100%;
    display: flex;
    flex-direction: row;
    > .course-bottom-left {
      width: 850px;
      height: 100%;
      display: flex;
      flex-direction: column;
      // border:1px solid rgba(234,234,234,1);
      margin-top: 10px;
      > .course-describe {
        width: 850px;
        height: 100%;
        > .ue-tabs {
          width: 100%;
          max-width: 850px;
          > ul {
            display: flex;
            align-items: center;
            justify-content: flex-start;
            margin: 0;
            height: 74px;
            padding-left: 0;
            transition: transform 0.3s;
            transform: translateX(0px);
            width: 100%;
            > li {
              display: inline-block;
              list-style: none;
              font-size: 16px;
              color: rgba(51, 51, 51, 1);
              padding: 0 20px;
              text-align: center;
              text-transform: uppercase;
              height: 74px;
              // width: 68px;
              line-height: 74px;
              font-family: MicrosoftYaHei;
              flex-grow: 0;
              flex-shrink: 0;
              &:hover {
                cursor: pointer;
                color: rgba(231, 0, 18, 1);
                font-weight: bold;
              }
              &::after {
                display: block;
                content: attr(title);
                font-weight: bold;
                visibility: hidden;
                height: 1px;
                color: transparent;
                margin-bottom: -1px;
                overflow: hidden;
              }
            }
            .active {
              color: rgba(231, 0, 18, 1);
              font-weight: bold;
              border-bottom: 3px solid rgba(231, 0, 18, 1);
            }
          }
        }

        > .course-relative {
          width: 100%;
          height: 100%;
          > .comment {
            > .course-comment-title {
              padding: 30px 0;
              border-bottom: 1px solid #eaeaea;
              margin-bottom: 22px;
              width: 850px;
              height: 67px;
              > span {
                float: left;
                display: inline-block;
                font-size: 16px;
                font-family: MicrosoftYaHei-Bold;
                font-weight: bold;
                color: rgba(51, 51, 51, 1);
                line-height: 16px;
                height: 16px;
                padding-left: 10px;
                border-left: 4px solid #e70012;
              }
            }
          }
          > .brief {
            margin-bottom: 52px;
            > .course-brief-title {
              padding: 30px 0;
              width: 850px;
              > span {
                float: left;
                display: inline-block;
                font-size: 16px;
                font-family: MicrosoftYaHei-Bold;
                font-weight: bold;
                color: rgba(51, 51, 51, 1);
                line-height: 16px;
                height: 16px;
                padding-left: 10px;
                border-left: 4px solid #e70012;
              }
            }
            > .brief-context {
              height: 100%;
              text-align: left;
              // background-color: red;
              margin-top: 2px;
              font-size: 14px;
              font-family: MicrosoftYaHei-Bold;
              // font-weight:bold;
              color: rgba(153, 153, 153, 1);
              line-height: 29px;
              > p {
                font-weight: bold;
                margin: 0;
                padding: 0;
              }
            }
          }
          > .source {
            margin-bottom: 52px;
            > .course-source-title {
              padding: 22px 0;
              width: 850px;
              > span {
                float: left;
                display: inline-block;
                font-size: 16px;
                font-family: MicrosoftYaHei-Bold;
                font-weight: bold;
                color: rgba(51, 51, 51, 1);
                line-height: 16px;
                height: 16px;
                padding-left: 10px;
                border-left: 4px solid #e70012;
              }
            }
            > .source-context {
              width: 850px;
              height: 548px;
              margin-top: 10px;
              box-shadow: 0px 0px 16px 0px rgba(51, 51, 51, 0.1);
              > .source-iframe {
                width: 850px;
                height: 492px;
                border: 20px solid rgba(18, 18, 18, 1);
              }
              > p {
                padding: 0;
                margin: 0;
                font-size: 16px;
                font-family: MicrosoftYaHei-Bold;
                font-weight: bold;
                color: rgba(51, 51, 51, 1);
                line-height: 28px;
                text-align: left;
                padding-left: 20px;
                margin-top: 12px;
                width: 500px;
                float: left;
              }
              > .source-download {
                width: 110px;
                height: 38px;
                float: right;
                background: rgba(0, 147, 231, 1);
                border-radius: 28px;
                margin-right: 20px;
                margin-top: 9px;
                display: flex;
                flex-direction: row;
                > .download-img {
                  width: 20px;
                  height: 20px;
                  background-image: url("../assets/img/download.png");
                  background-size: cover;
                  margin-left: 26px;
                  margin-top: 9px;
                }
                > .download-text {
                  width: 32px;
                  height: 28px;
                  font-size: 16px;
                  font-family: MicrosoftYaHei-Bold;
                  font-weight: bold;
                  color: rgba(255, 255, 255, 1);
                  line-height: 28px;
                  margin-left: 10px;
                  margin-top: 5px;
                }
              }
            }
          }
        }
      }
      > .course-cards-box {
        width: 850px;
        height: 100%;
        margin-top: 13px;
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        justify-content: space-between;
        align-items: center;
         > .course-cards {
           margin-bottom: 50px;
         }
        > .course-cards-text {
          > p {
            width: 850px;
            height: 35px;
            text-align: left;

            font-size: 16px;
            font-family: MicrosoftYaHei;
            color: rgba(51, 51, 51, 1);
            line-height: 21px;
            -webkit-text-stroke: 1px rgba(151, 151, 151, 1);
            text-stroke: 1px rgba(151, 151, 151, 1);
            border-bottom: 1px solid rgba(234, 234, 234, 1);
          }
        }
      }
    }
    > .course-bottom-right {
      display: flex;
      flex-direction: column;
      margin-top: 40px;
      width: 280px;
      margin-left: 47px;
      border-radius: 6px;
    }
  }
}
</style>
